import { io, Socket } from "socket.io-client";
import { plainToClass } from 'class-transformer';

type MessageClassType<T> = {
    new (...args: any[]): T;
    sClassName: string;
};

export class SocketIOClient {
    private static instance: SocketIOClient;

    private socket: Socket;

    //Storing the class and the handler
    private handlers: Map<string, { messageClass: new (...args: any[]) => any; handler: (data: any) => void }> = new Map();


    private constructor() {
        this.socket = io('/', {
            path: "/api/socket.io",
        });
        
        this.setupListener();

        this.socket.on('connect_error', (error: any) => {
            console.log("connect_error", error);
        });

        this.socket.on('error', (error: any) => {
            console.error('error:', error); 
        });
    }

    public static getInstance(): SocketIOClient {
        if (!SocketIOClient.instance) {
            SocketIOClient.instance = new SocketIOClient();
        }
        return SocketIOClient.instance;
    }

    public setupListener(): void {
        this.socket.on('message', (data: any) => {
            const entry = this.handlers.get(data.className);

            console.log(entry)
            if (entry) {
                const instance = plainToClass(entry.messageClass, data);
                entry.handler(instance);
            } else {
                console.warn(`No handler registered for message type: ${data.type}`);
            }
        });
    }

    public addHandler<T>(messageClass: MessageClassType<T>, handler: (data: T) => void): void {
        this.handlers.set(
            messageClass.sClassName, 
            { messageClass, handler }
        );
    }

    public subscribeToHubIDTopic(input: { hubID: string }): void {
        this.socket.emit('subscribe_hub_id', input);
        console.log(`Subscribed to topic: ${input.hubID}`);
    }

    public unsubscribeFromTopic(topic: string): void {
        this.socket.emit('unsubscribe', topic);
        console.log(`Unsubscribed from topic: ${topic}`);
    }

    public disconnect(): void {
        this.socket.disconnect();
    }
}

export abstract class PublishMessage {
    public topic!: string;
    public abstract get className(): string;
}